window.whalewisdom.CsvExport = {
  init: function () {
    jQuery('#cmd-advanced-export').click(function () {
      jQuery('#csv_export_dialog').modal({
        keyboard: true
      }).on('shown.bs.modal', function () {
        //   jQuery('#csv-export-columns').multiselect({selectedList:4,noneSelectedText:"Select columns to export"});
        //   jQuery('#csv-export-quarters').multiselect({selectedList:4,noneSelectedText:"Select quarters to include"});
      })
      jQuery('#csv_export_dialog').on('shown.bs.modal', function (e) {
        //    jQuery('#csv-export-columns').multiselect({selectedList:4,noneSelectedText:"Select columns to export"});
        //    jQuery('#csv-export-quarters').multiselect({selectedList:4,noneSelectedText:"Select quarters to include"});
      })
    })

    jQuery('#cmd-schedule-csv-export').click(whalewisdom.CsvExport.exportcsv)

    /* jQuery('#csv-export-columns').multiselect({sortable:true, searchable:false});
        jQuery('#csv-export-quarters').multiselect({sortable:true, searchable:false});
        jQuery('.ui-multiselect ul').css('height','50px');
        jQuery('.ui-multiselect').css('width','350px');
        jQuery('.ui-multiselect ul').css('width','174px');
        jQuery('.ui-multiselect .selected').css('width','174x');
        jQuery('.ui-multiselect .available').css('width','174px');
         {columns:3,placeholder:'Select States',search:true,searchOptions:{'default':'Search States'},selectAll:true}
         */
    jQuery('#csv-export-columns').multiselect({ columns: 3,
      selectAll: true,
      texts: {
        placeholder: 'Select columns to export'
      } })
    jQuery('#csv-export-quarters').multiselect({ columns: 4,
      selectAll: true,
      texts: {
        placeholder: 'Select quarters to include'
      } })
  },
  exportcsv: function () {
    /*if (jQuery('#cmd-schedule-csv-export').hasClass('disabled')) {
      return
    }*/
    // validate at least one column and quarter selected and email address is not blank  and output selected
    var columns = jQuery('#csv-export-columns').val()
    var quarters = jQuery('#csv-export-quarters').val()
    var email = jQuery('#export-email').val()
    var output = jQuery('input[name=rdo-output]:checked').val()
    jQuery('.control-group').removeClass('error')
    jQuery('#csv-export-alert').html('')
    var message = ''
    if (!columns || columns.length == 0) {
      message += '<div>Please select at least one column to export.</div>'
      jQuery('#csv-export-columns').parents('.control-group').addClass('error')
    }
    if (!quarters || quarters.length == 0) {
      message += '<div>Please select at least one quarter</div>'
      jQuery('#csv-export-quarters').parents('.control-group').addClass('error')
    }
    if (!email || email.length == 0) {
      message += '<div>Please enter an email address to send the export to</div>'
      jQuery('#export-email').parents('.control-group').addClass('error')
    }
    if (!output || output <= 0 || output > 2) {
      message += '<div>Please select a valid output</div>'
      jQuery('#rdo-output-single').parents('.control-group').addClass('error')
    }
    if (message.length > 0) {
      jQuery('#csv-export-alert').show()
      jQuery('#csv-export-alert').html(message)
      return
    }
    if (!whalewisdom.Utilities.isSubscriber()) {
      jQuery('#csv-export-alert').show()
      jQuery('#csv-export-alert').html('This feature requires a subscription to use.')
      return
    }
    jQuery('#cmd-schedule-csv-export').html('Please wait...')
    jQuery('#cmd-schedule-csv-export').addClass('disabled')
    jQuery('#csv-export-alert').html('')
    var params = 'filer_id=' + whalewisdom.Filer.filer_id + '&output=' + output + '&columns=' + columns + '&quarters=' + quarters +
          '&email=' + email
    jQuery.ajax({
      url: '/filer/export_csv',
      dataType: 'text',
      data: params,
      success: function (results) {
        jQuery('#cmd-schedule-csv-export').removeClass('disabled')
        jQuery('#cmd-schedule-csv-export').html('Schedule Export')
        jQuery('#csv_export_dialog').modal('hide')
        //  whalewisdom.Utilities.wait_dialog.hide();
        whalewisdom.Utilities.show_alert('Export has been placed in queue',
          'Your export has been placed in the queue and you should receive an email shortly when it is completed')
      },
      error: function (d) {
        //     whalewisdom.Utilities.wait_dialog.hide();
        jQuery('#cmd-schedule-csv-export').removeClass('disabled')
        jQuery('#cmd-schedule-csv-export').html('Schedule Export')
        jQuery('#csv-export-alert').show()
        jQuery('#csv-export-alert').html('Sorry, there was a problem scheduling your export. Please try again or report this problem via the "Contact Us" page.')
        // whalewisdom.Utilities.show_alert("Error generating export",d);
      }
    })
  }
}
jQuery(function () {
  window.whalewisdom.CsvExport.init()
})
